import type { STDocument } from '@st/sdk'
import { StatusStampsDocumentBanner } from '~/st-doc-viewer/plugins/sign-offs/ui'
import type { DocumentViewerTopBarProps } from '../top-bar-types'

export const renderDefaultDocumentViewerTopBar = (
  document: STDocument,
  { sendViewerMessage }: DocumentViewerTopBarProps
) => <StatusStampsDocumentBanner title={document.name} sendViewerMessage={sendViewerMessage} />
